<template>
  <div class="vbtnc focus-s" :style="{right: right, bottom: bottom}">
    <SvgIcon svgname="ic_add1" :size="20" fill="white"></SvgIcon>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
  name: 'FloatingButton',
  components:{
    SvgIcon
  },
  props: {
    right:{
        type:String,
        default:"20px"
    },
    bottom:{
        type:String,
        default:"20px"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vbtnc{
    width: 40px;
    height: 40px;
    background: var(--ek-color-primary);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    box-shadow: 2px 3px 5px #00000052;
}
</style>
